import { Container } from "../components/common-components";
import { FormHeader } from "../components/FormHeader";
import { FormFooter } from "../components/FormFooter";
import { ServiceInfo } from "../components/ServiceInfo";
import { PatientInformation } from "../components/PatientInformation";
import { PatientContactInformation } from "../components/PatientContactInformation";
import { AlternateCaregiverInformation } from "../components/AlternateCaregiverInformation";
import { ConsentInformation } from "../components/ConsentInformation";
import { AllergyInformation } from "../components/AllergyInformation";
import { MedicalHistorySection } from "../components/MedicalHistorySection";
import { PrescribingPharmacistInformation } from "../components/PrescribingPharmacistInformation";
import { PharmacyInformation } from "../components/PharmacyInformation";
import { CoverLetter } from "../components/CoverLetter";
import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { GetAllReferrals } from "../common/GetAllReferrals";
import { AlertConfirmationTypes } from "../../../helpers/constant";
import { ReferralAlertInformation } from "../components/ReferralAlertInformation";
import { ReferralsAndNotifications } from "../components/ReferralsAndNotifications";
import { NotificationOfService } from "../components/NotificationOfService";

export const PhysicianReferralForm = () => {
  const { formType, patient, preAssessment, documentation, clinicalServiceName,
    startDateTime,
    endDateTime } = useContext(FormContextMA);
  const { referralInformations, notificationInformations } =
    documentation || {};

  return (
    <div className="space-y-20">
      {referralInformations?.length > 0 ? (
        referralInformations?.map((ref) => (
          <>
            <Container>
              <CoverLetter referral={ref} isReferral={true} />
            </Container>
            <Container>
              <FormHeader formType={formType} />
              <div className="mx-[0.375in] mt-[0.25in] min-h-[800px]">
                <ServiceInfo 
                  referral={ref} 
                  isReferral={true}
                  formType = {formType}
                  clinicalServiceName = {clinicalServiceName}
                  patient = {patient}
                  startDateTime = {startDateTime} />
                <PatientInformation formType = {formType} patient = {patient} preAssessment = {preAssessment}/>
                <PatientContactInformation formType = {formType} patient = {patient}/>
                <AlternateCaregiverInformation formType = {formType} patient = {patient}/>
                <ReferralAlertInformation documentation={documentation} formType={formType} />
                <PrescribingPharmacistInformation formType ={formType} startDateTime={startDateTime} endDateTime={endDateTime} />
              </div>
              <FormFooter />
            </Container>
          </>
        ))
      ) : (
        <>
          <Container>
            <CoverLetter referral={null} isReferral={true} />
          </Container>
          <Container>
            <FormHeader formType={formType} />
            <div className="mx-[0.375in] mt-[0.25in] min-h-[800px]">
              <ServiceInfo 
                  referral={null} 
                  isReferral={true}
                  formType = {formType}
                  clinicalServiceName = {clinicalServiceName}
                  patient = {patient}
                  startDateTime = {startDateTime} />
              <PatientInformation formType = {formType} patient = {patient} preAssessment = {preAssessment}/>
              <PatientContactInformation formType = {formType} patient = {patient}/>
              <AlternateCaregiverInformation formType = {formType} patient = {patient}/>
              <ReferralAlertInformation documentation={documentation} formType={formType} />
              <PrescribingPharmacistInformation formType ={formType} startDateTime={startDateTime} endDateTime={endDateTime} />
            </div>
            <FormFooter />
          </Container>
        </>
      )}
    </div>
  );
};
